<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Change Bill Date

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="SaveDate()" #f="ngForm">
          <div class="modal-body padding-top-0px">
            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName">Bill No :</label>
                      </div>
                      <div class="col-md-4">
                        <label class="margin-bottom-0px margin-left-5px">{{BillNo}}</label>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName">Modified Date :</label>
                      </div>
                      <div class="col-md-4">
                        <div class="date-form">
                          <input class="form-control form-control-patient" placeholder="Date"
                                 name="dps" [(ngModel)]="NewDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}"
                                 required #d1fe="ngbDatepicker" #DOBfe="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!DOBfe.valid && (DOBfe.dirty || DOBfe.touched) && DOBfe.errors.required)">(Field cannot be left blank)</small>

                          <a (click)="d1fe.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>


         

















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
